module.exports = __webpack_public_path__ + "static/img/pic_ppt_big@2x.98beb9c4.png";